import * as Sentry from '@sentry/react';

export function initSentry() {
  const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development';

  if (environment === 'development') return;

  Sentry.init({
    dsn: 'https://25ef161796dd0673f61becb0ffa95978@o4510829604044800.ingest.us.sentry.io/4510829605683200',
    environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
